import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteColor, GetColor } from "../../../redux/actions/productActions";
import DataTable from "react-data-table-component";
import SearchHeader from "../../common/header_components/searchHeader";
import { toast } from "react-toastify";
import { RESET_ERROR } from "../../../redux/constants/userConstants";
import AddColor from "./AddColor";
import moment from "moment";

const Color = () => {
    const dispatch = useDispatch();
    const { getcolorlist, colordelsuccess, editedcolor, newcolor, error } = useSelector(state => state.product);
    const [datas, setDatas] = useState([]);
    const [open, setOpen] = useState(false);
    const [activeData, setActiveData] = useState(null);
    const [title, setTitle] = useState("");
    const [filterText, setFilterText] = useState("");

    const customToast = "delCol";
    const customCToast = "addCol";
    const customUToast = "editCol";

    const Capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this color?")) {
            dispatch(DeleteColor(id));
        }
    };

    const handleEdit = (data) => {
        setTitle("Edit Color");
        setActiveData(data);
        setOpen(true);
    };

    const onOpenModal = () => {
        setTitle("Add Color");
        setActiveData(null);
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
    };

    useEffect(() => {
        dispatch(GetColor());
    }, []);

    useEffect(() => {
        if (getcolorlist) {
            setDatas(getcolorlist);
        }
    }, [getcolorlist]);

    useEffect(() => {
        if (colordelsuccess) {
            toast.success("Color deleted successfully", { toastId: customToast });
            dispatch({ type: RESET_ERROR });
        }
    }, [colordelsuccess]);

    useEffect(() => {
        if (newcolor) {
            toast.success("Color created successfully", { toastId: customCToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [newcolor]);

    useEffect(() => {
        if (editedcolor) {
            toast.success("Color updated successfully", { toastId: customUToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [editedcolor]);

    useEffect(() => {
        if (error) {
            toast.error(`${error.message}`);
            dispatch({ type: RESET_ERROR });
        }
    }, [error]);

    const columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Created Date")}</b>,
            header: <b>{Capitalize("Created Date")}</b>,
            selector: row => moment(row?.created_at).format('DD-MM-YYYY'),
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Color")}</b>,
            header: <b>{Capitalize("Color")}</b>,
            selector: row => row?.name,
            style: { textAlign: "center" },
        },
        {
            name: <b>Actions</b>,
            id: "actions",
            cell: (row) => (
                <>
                    <span onClick={() => handleDelete(row._id)}>
                        <i
                            className="fa fa-trash"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "#e4566e", cursor: "pointer" }}
                        ></i>
                    </span>
                    <span onClick={() => handleEdit(row)}>
                        <i
                            className="fa fa-pencil"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "rgb(40, 167, 69)", cursor: "pointer" }}
                        ></i>
                    </span>
                </>
            )
        }
    ];

    useEffect(() => {
        const filtered = getcolorlist?.filter(col =>
            col?.name?.toLowerCase().includes(filterText?.toLowerCase())
        );
        setDatas(filtered);
    }, [filterText]);

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);

    return (
        <Fragment>
            <Breadcrumb title="Color" parent="Products" />
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Color</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                    >
                                        Add Color
                                    </Button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination
                                        columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <AddColor
                openModal={open}
                onCloseModal={() => {
                    setActiveData(null);
                    setOpen(false);
                }}
                data={activeData}
                setActiveData={setActiveData}
                title={title}
            />
        </Fragment>
    );
};

export default Color;

